import { Button, Grid, Box, Rating } from "@mui/material";
import { AddShoppingCartOutlined } from "@mui/icons-material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, addToCart }) => {
  return (
    <Grid item xs={12} sm={6} md={3} lg={3}>
      <Box className="product-card">
        {/* Product Image */}
        <img className="product-image" src={product.image} alt={product.name} />
        <Box className="product-details">
          <p className="product-name">{product.name}</p>
          <p className="product-category">{product.category}</p>
          <p className="product-price">${product.cost}</p>
          <Box className="rating">
            <Rating name="read-only" value={product.rating} readOnly />
          </Box>
          {/* Add to Cart */}          
          <Button
            variant="contained"
            fullWidth
            startIcon={<AddShoppingCartOutlined />}
            onClick={() => addToCart(product._id,1)}>
            Add to cart
          </Button>

        </Box>
      </Box>
    </Grid>
  );
};

export default ProductCard;
